/**
 */

import type {
  AppendStreamPayload,
  ChatMessageEntity,
  FailStreamingPayload,
} from './chat-message-entity.interface'
import type { ChatState } from './chat-state.interface'

export const handleAppendToItemStream = (state: ChatState, payload: AppendStreamPayload): void => {
  const message = state.messageEntities[payload.itemId]
  if (message) {
    message.streamingContent += payload.content
  }
}

export const handleFailItemStreaming = (state: ChatState, payload: FailStreamingPayload): void => {
  const message = state.messageEntities[payload.itemId]
  if (!message) return
  message.isStreaming = false
  message.errorMessage = payload.errorMessage
}

export interface CompleteAllConversationEntityStreamingPayload {
  conversationId: string
}

const finalizeStreamingEntity = (entity: ChatMessageEntity): void => {
  entity.content = entity.streamingContent || entity.content
  entity.isStreaming = false
  entity.streamingContent = ''
}

const resetStreamingEntity = (entity: ChatMessageEntity): void => {
  entity.isStreaming = false
  entity.streamingContent = ''
}

const forEachStreamingEntityInConversation = (
  state: ChatState,
  conversationId: string,
  visit: (entity: ChatMessageEntity) => void
): void => {
  const idList = state.messageIdsByConversation[conversationId] ?? []
  for (const id of idList) {
    const entity = state.messageEntities[id]
    if (entity?.isStreaming) visit(entity)
  }
}

export const handleClearConversationStreaming = (
  state: ChatState,
  payload: CompleteAllConversationEntityStreamingPayload
): void => {
  forEachStreamingEntityInConversation(state, payload.conversationId, resetStreamingEntity)
}

export const handleCompleteAllConversationEntityStreaming = (
  state: ChatState,
  payload: CompleteAllConversationEntityStreamingPayload
): void => {
  forEachStreamingEntityInConversation(state, payload.conversationId, finalizeStreamingEntity)
}

export interface FinalizeEntityStreamingPayload {
  entityId: string
}

export const handleFinalizeEntityStreaming = (
  state: ChatState,
  payload: FinalizeEntityStreamingPayload
): void => {
  const entity = state.messageEntities[payload.entityId]
  if (!entity || !entity.isStreaming) return
  finalizeStreamingEntity(entity)
}
